import { render, staticRenderFns } from "./MultiplePackagesCreation.vue?vue&type=template&id=33323cda&scoped=true&"
import script from "./MultiplePackagesCreation.vue?vue&type=script&lang=js&"
export * from "./MultiplePackagesCreation.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePackagesCreation.vue?vue&type=style&index=0&id=33323cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33323cda",
  null
  
)

export default component.exports